import React, { useEffect, useState } from 'react'
import BbfsBet from './BbfsSubComponent/BbfsBet';
import { useDispatch, useSelector } from "react-redux";
import BbfsBetVersiWap from './BbfsSubComponent/BbfsBetVersiWap';
import VersiWAP from '../../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo';
import { set4dGameSubChildtype, setCommonConfig } from '../../../../../redux/actions';
import MarketClose from "../../MarketClose";
import ZeroBalancePopup from "../../ZeroBalancePopup";
import GameClosedPopup from "../../GameClosedPopup";
import { withTranslation } from 'react-i18next';

const Bbfs = (props) => {
  const dispatch = useDispatch();
  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const user_profile = useSelector(state => state.UserProfile);
  const clickTab = useSelector((state) => state.CommonConfig.clickTab);
  const [multipleValue, setMultipleValue] = useState('');
  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: tabIndex == "1" ? "DISCOUNT" : tabIndex == "2" ? "FULLBET" : tabIndex == "3" ? "PRIZE" : "" }));
  };

  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = marketStatus.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = marketStatus.showMultipleFullbet;
    } else {
      multiple = marketStatus.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type]);

  useEffect(() => {
    setActiveTab(1);
    dispatch(setCommonConfig({ key: 'gameType', value: 'bbcampuran' }));
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
    dispatch(setCommonConfig({ key: 'clickTab', value: 0 }));
  }, [clickTab])

  return (
    <>
      <div className="inner_nav-tabwrapper">
        {marketStatus.fullbetStatus == 0 && marketStatus.prize123Status == 0 ? '' :

          <div
            className={`inner_tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => handleTabClick(1)}
          >
            DISCOUNT
          </div>
        }
        {marketStatus.fullbetStatus == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 2 ? "active" : ""}`}
            onClick={() => handleTabClick(2)}
          >
            FULLBET
          </div>
        }
        {marketStatus.prize123Status == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 3 ? "active" : ""}`}
            onClick={() => handleTabClick(3)}
          >
            PRIZE 1,2,3
          </div>
        }
      </div>
      {
        device === "Mobile" ? (
          <>
            {/* --- Rules ---  */}
            {app_type === "wap" ?
              <div className='rules_container'>
                <div>
                  <p>{props.t('guess_exact_number')}</p>
                  <p>Format Tarun: nomar1*nomar2*nomar3#bet+
                    namor1*namor2#bet</p>
                  <p>Conoth Penulisan: 123*1234*12#5000+11*222*333
                    #1000+33*777#2000</p>
                </div>
                <div className='rules_conversion'>
                  <p>Konversi <br /> 1 = {multipleValue}</p>
                </div>
              </div>
              : ""}
          </>
        ) : null
      }
      <div className="tabcontent-wrapper">
        {activeTab === 1 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <BbfsBetVersiWap betType="discount" /> : <BbfsBet betType="discount" />))}</div>}
        {activeTab === 2 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <BbfsBetVersiWap betType="fullbet" /> : <BbfsBet betType="fullbet" />))}</div>}
        {activeTab === 3 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <BbfsBetVersiWap betType="prize123" /> : <BbfsBet betType="prize123" />))}</div>}
      </div>
    </>
  )
}

export default withTranslation()(Bbfs);